module.exports = __webpack_public_path__ + "static/assets/fc383956e315b7ee2bd8dd09de311701.mp3";